import { render, staticRenderFns } from "./FlightPaxes.vue?vue&type=template&id=41876ed5&scoped=true"
import script from "./FlightPaxes.vue?vue&type=script&lang=js"
export * from "./FlightPaxes.vue?vue&type=script&lang=js"
import style0 from "./FlightPaxes.vue?vue&type=style&index=0&id=41876ed5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41876ed5",
  null
  
)

export default component.exports